module.exports = __webpack_public_path__ + "img/23.9.TU.c56efd82.png";